import { initThemeToggle } from "./theme";
import { initCopyLink } from "./share";

document.addEventListener("DOMContentLoaded", () => {
    initThemeToggle();
    initCopyLink();
});
